<!-- Contact Component -->
<script>
  import { Col, Row, Container, FormGroup, Input } from "sveltestrap";
  
    

</script>


<!-- CONTACT FORM START-->
<section class="section common-section" id="contact">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">Contact Us</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle text-muted text-center font-secondary pt-4">
          We look forward to hearing from you and will do everything in our power to get back to you promptly.<br>
          To request a free quote, email, call or text us using the information below:
        </p>    
      </Col>
    </Row>
    <Row>
      <Col lg="4">
        <div class="mt-4 pt-4">
          <p class="mt-4">
            <span class="h5">Areas we service:</span><br />
            <span class="text-muted d-block mt-2"
              >Northern NJ</span
            >
          </p>
          <p class="mt-4">
            <span class="h5">How to reach us:</span><br />
            <span class="text-muted d-block mt-2">Call or text this number, or email us.</span>
          </p>
        </div>
      </Col>

      <Col lg="8">
        <div class="custom-form mt-4 pt-4">
          <section class="contact-social bg-light">
            <Container>
              <Row class="align-items-center">               
                <Col lg="6" class="mt-5">
                  <p class="contact-title">
                    <i class="pe-7s-call" />
                  </p>
                  <p class="contact-title">
                     <a href="tel:551-278-8200" target="_system">(551)278-8200</a>
                  </p>
                </Col>
                <Col lg="6" class="mt-5">
                  <p class="contact-title">
                    <i class="pe-7s-mail-open" />
                  </p>                  
                  <p class="contact-title">
                    <a href="mailto:Info@allaxishomeinspections.com">Info@allaxishomeinspections.com</a>
                  </p>         
                </Col>
              </Row>
            </Container>
        </div>
      </Col>
    </Row>
  </Container>
</section>
<!-- CONTACT FORM END-->
